import RegisterForm from "../../components/auth/registerform/RegisterForm"
export default function Register() {
    return (
        <>
            <RegisterForm/>
        </>
    );
}